import {createAxios} from './createAxios';

export const investorApiClient = createAxios(process.env.REACT_APP_API_URL as string);
